import { render, staticRenderFns } from "./RecentDocs.vue?vue&type=template&id=2e97b4f8&scoped=true"
import script from "./RecentDocs.vue?vue&type=script&lang=js"
export * from "./RecentDocs.vue?vue&type=script&lang=js"
import style0 from "./RecentDocs.vue?vue&type=style&index=0&id=2e97b4f8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e97b4f8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e97b4f8')) {
      api.createRecord('2e97b4f8', component.options)
    } else {
      api.reload('2e97b4f8', component.options)
    }
    module.hot.accept("./RecentDocs.vue?vue&type=template&id=2e97b4f8&scoped=true", function () {
      api.rerender('2e97b4f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/utils/RecentDocs.vue"
export default component.exports